module.exports = __webpack_public_path__ + "static/media/five-blokes-sample.6f665c13.png";